<template>
  <div>
    <h1>Welcome to Solana Token Access</h1>
    <button v-if="!walletConnected && !loading" @click="connectWallet">
      Connect Phantom Wallet
    </button>
    <div v-if="loading">Checking token ownership...</div>
    <div v-else-if="walletConnected">
      <p>Wallet Address: {{ walletAddress }}</p>
      <button @click="checkToken">Check Token</button>
      <p v-if="tokenFound">
        🎉 Access Granted!
        <router-link to="/dashboard">Go to Dashboard</router-link>
      </p>
      <p v-else-if="checked && !tokenFound">❌ Token Not Found!</p>
    </div>
    <div v-if="error" class="error-message">{{ error }}</div>
  </div>
</template>

<script>
import { Connection, PublicKey } from "@solana/web3.js";

export default {
  name: "HomeView",
  data() {
    return {
      walletConnected: false,
      walletAddress: "",
      tokenFound: false,
      checked: false,
      loading: false,
      error: null,
      connection: null,
    };
  },
  methods: {
    async connectWallet() {
      if (window.solana && window.solana.isPhantom) {
        try {
          const response = await window.solana.connect({
            onlyIfTrusted: false,
          });
          this.walletConnected = true;
          this.walletAddress = response.publicKey.toString();
          this.connection = new Connection(
            "https://mainnet.helius-rpc.com/?api-key=0d6562be-08f2-4659-92bb-54fbcadd00b2"
          );
          this.error = null;
        } catch (err) {
          console.error("Wallet connection failed:", err);
          this.error = "Failed to connect Phantom Wallet. Please try again.";
        }
      } else {
        alert("Please install Phantom Wallet!");
      }
    },

    async checkToken() {
      if (!this.walletAddress || !this.connection) return;

      const TOKEN_MINT_ADDRESS = "2j3KBSiHUkgFkSNhqsMS4y26iiHSGouwXBMzEnmZ1mqC"; // Replace with your token mint address
      this.loading = true;
      this.error = null;
      this.tokenFound = false;

      try {
        console.log("Wallet Address:", this.walletAddress);
        console.log("Token Mint Address:", TOKEN_MINT_ADDRESS);

        const accounts = await this.connection.getParsedTokenAccountsByOwner(
          new PublicKey(this.walletAddress),
          {
            programId: new PublicKey(
              "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
            ),
          }
        );

        console.log("Fetched Token Accounts:", accounts);

        // Search for the token mint in fetched accounts
        this.tokenFound = accounts.value.some(
          (account) =>
            account.account.data.parsed.info.mint === TOKEN_MINT_ADDRESS
        );

        console.log("Token Found:", this.tokenFound);

        if (this.tokenFound) {
          console.log("Access Granted! Navigating to the dashboard...");
          localStorage.setItem("isAuthenticated", "true"); // Mark user as authenticated
          this.$router.push({
            name: "DashboardView",
            query: {
              walletAddress: this.walletAddress,
              tokenMint: TOKEN_MINT_ADDRESS,
            },
          });
        } else {
          console.warn("Token not found in wallet.");
          this.error = "Token not found in your wallet.";
          localStorage.removeItem("isAuthenticated"); // Ensure unauthenticated state
        }
      } catch (err) {
        console.error("Error checking token ownership:", err);
        this.error = "Failed to verify token ownership. Please try again.";
        localStorage.removeItem("isAuthenticated"); // Ensure unauthenticated state
      } finally {
        this.checked = true;
        this.loading = false;
      }
    },
  },
  async mounted() {
    if (window.solana?.isPhantom) {
      try {
        const response = await window.solana.connect({ onlyIfTrusted: true });
        this.walletConnected = true;
        this.walletAddress = response.publicKey.toString();
        this.connection = new Connection(
          "https://mainnet.helius-rpc.com/?api-key=0d6562be-08f2-4659-92bb-54fbcadd00b2"
        );
      } catch (err) {
        console.warn("Automatic wallet connection failed:", err);
      }
    }
  },
};
</script>

<style>
button {
  margin: 10px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}
.error-message {
  color: red;
  margin-top: 20px;
}
</style>
